export default {
    infoData: {
        companyName: '', // 分公司
        siteName: '', // 服务平台
        ledgerName: '', // 会计主体
        payChangeCashAmt: '', // 应收转押金金额
        businessProperty: '', // 业务类型
        contractName: '', // 合同名称
        suppliersCashType: '', // 押金类型
        toAmt: '', // 现汇金额
        penaltyAmt: '', // 罚扣款金额
        actualRefund: '', // 实际退款
        theReturnAmt: '', // 计划退款
        remark: '', // 备注
        // rownum: '', // 招标项目名称
        currencyCode: '', // 币种
        createTime: '', // 创建日期
        budgetAmt: '', // 押金金额
        balanceAmt: '', // 余额
        statusText: '' // 合同状态
    },
    tableDataCollects: [
        {
            prop: 'applyNo',
            label: '申请单号',
            type: 'normal'
        },
        {
            prop: 'applyTime',
            label: '申请日期',
            type: 'normal'
        },
        {
            prop: 'payTypeText',
            label: '缴纳方式',
            type: 'normal'
        },
        {
            prop: 'approveStatusType',
            label: '审核状态',
            type: 'normal'
        },
        // {
        //     prop: 'taskCount',
        //     label: '缴纳状态',
        //     type: 'normal'
        // },
        {
            prop: 'apApplyNo',
            label: '应收转押金单号',
            type: 'normal'
        },
        {
            prop: 'fromSupCashNo',
            label: '押金调账单号',
            type: 'normal'
        },
        {
            prop: 'cashPaymentAmt',
            label: '现汇付款金额',
            type: 'normal'
        },
        {
            prop: 'receivableAmt',
            label: '应收转押金金额',
            type: 'normal'
        },
        {
            prop: 'transfersAmt',
            label: '押金调账金额',
            type: 'normal'
        },
        {
            prop: 'isElectronicSignStr',
            label: '是否电子签章',
            type: 'normal'
        },
        {
            prop: 'eSignatureStr',
            label: '电子签章状态',
            type: 'normal'
        },
        {
            prop: 'approveBy',
            label: '审核人',
            type: 'normal'
        },
        {
            prop: 'approveOpinion',
            label: '审核意见',
            type: 'normal'
        },
        {
            prop: 'approveDate',
            label: '审核日期',
            type: 'normal'
        }
    ],
    tableDataRefunds: [
        {
            prop: 'applyNo',
            label: '退款单号',
            type: 'normal'
        },
        {
            prop: 'applyTime',
            label: '退款申请日期',
            type: 'normal'
        },
        {
            prop: 'applyAmt',
            label: '退款金额',
            type: 'normal'
        },
        {
            prop: 'accountName',
            label: '银行账号',
            type: 'normal'
        },
        {
            prop: 'bankAccount',
            label: '开户行',
            type: 'normal'
        },
        {
            prop: 'bankAccountName',
            label: '账户名称',
            type: 'normal'
        },
        {
            prop: 'isEsignature',
            label: '是否电子签章',
            type: 'normal'
        },
        {
            prop: 'approveBy',
            label: '审核人',
            type: 'normal',
            status: 'link'
        },
        {
            prop: 'approveDate',
            label: '审核日期',
            type: 'normal',
            status: 'link'
        },
        {
            prop: 'approveOpinion',
            label: '审核意见',
            type: 'normal',
            status: 'link'
        },
        {
            prop: 'approveStatusType',
            label: '审核状态',
            type: 'normal',
            status: 'link'
        }
    ]
};
